import { useContext, useEffect, useState } from "react"
import { EventPreferencesForm } from "./eventView/EventPreferencesForm"
import { EventPreferencesResult } from "./eventView/EventPreferencesResult"
import { Event } from "../api.types"
import { CurrentUserContext, useHttp } from "../Context"
import { EventPropositionsForm } from "./eventView/EventPropositionsForm"

export enum EventStatus {
    Propositions = "propositions",
    PropositionsWait = "propositions-wait",
    Preferences = "preferences",
    PreferencesWait = "preferences-wait",
    Done = "done",
}

export function EventView(props: { eventId: string }) {
    const [event, setEvent] = useState<Event | undefined>(undefined)
    const {currentUser} = useContext(CurrentUserContext)
    const httpFetch = useHttp()
    const fetchEvent = () => {
        httpFetch(`/api/event/${props.eventId}`).then((resp: any) => {
            resp.json().then((data: Event) => {
                setEvent(data)
            })
        })
    }
    const changePreferences = async (fromId: string, toId: string) => {
        httpFetch(`/api/event/${props.eventId}/preferences`, {
            method: "PATCH",
            body: JSON.stringify({ fromId, toId }),
        }).then(() => { fetchEvent() })
    }
    useEffect(fetchEvent, [props.eventId, currentUser, httpFetch])

    if (event && (event.status === EventStatus.Propositions || event.status === EventStatus.PropositionsWait) && event.gamePropositionCountLimit !== undefined) {
        return (<EventPropositionsForm event={event} eventId={event.id} gamePropositionCount={event.gamePropositionCountLimit} onSend={fetchEvent} />)
    } else if (event && (event.status === EventStatus.Preferences || event.status === EventStatus.PreferencesWait)) {
        return (<EventPreferencesForm event={event} eventId={event.id} propositions={event.propositions || []} onSend={fetchEvent} />)
    } else if (event && event.status === EventStatus.Done && event.preferences !== undefined) {
        return (<EventPreferencesResult event={event} onPreferenceChange={changePreferences}/>)
    }
    return null
}


